export default __webpack_public_path__ + "static/media/icon6.271b4bdc.svg";